import { useEffect, useState } from "react";

import { ITableRowData } from "../../../shared/components/normal-table/normal-table";
import SimpleModal from "../../../shared/components/simple-modal/simple-modal";
import DataTable, { IColumn } from "../../components/data-table/data-table";

export interface IAssignUserPopupModalProps {
  show: boolean;
  handlePopupClosed(result: ITableRowData[] | undefined): void;
  handleAssignUser(userId: string): void;
}

const AssignUserPopup = ({
  show,
  handlePopupClosed,
  handleAssignUser,
}: IAssignUserPopupModalProps) => {
  const [selectedId, setSelectedId] = useState<string>("");
  const [showModal, setShowModal] = useState<boolean>(show);

  const columns: IColumn[] = [
    {
      key: "email",
      displayName: "Email Address",
      dataType: {
        type: "text",
      }
    },
    {
      key: "name",
      displayName: "First Name",
      dataType: {
        type: "text",
      }
    },
    {
      key: "last_name",
      displayName: "Last Name",
      dataType: {
        type: "text",
      }
    }
  ];

  useEffect(() => {
    setShowModal(show);
  }, [show]);

  const handleOnReferenceChange = (selectedIds: string[]) => {
    setSelectedId(selectedIds[0]);
  };

  const handleSubmit = () => {
    if (selectedId) {
      handleAssignUser(selectedId);
    }
  };

  const modalContent = () => {
    return (
      <div className="user-template-popup">
        <DataTable
          columns={columns}
          defaultSortCol="email"
          dataUrl={{
            url: "users",
            backend: "platform"
          }}
          selectionMode="single"
          onSelectionChange={handleOnReferenceChange}
        />
      </div>
    );
  };

  return (
    <SimpleModal
      modalBody={modalContent()}
      mode={"Assign to user"}
      handleModalClosed={() => handlePopupClosed(undefined)}
      handleSubmit={handleSubmit}
      show={showModal}
      buttonText="Assign"
    />
  );
};

export default AssignUserPopup;